import { ProductV2 } from '@common'
import cx from 'classnames'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

import DividerImage from '@/assets/images/storefronts/clashroyale/cr-divider.png'
import CoinsImage from '@/assets/images/storefronts/clashroyale/divider-coins.png'
import ScalesImage from '@/assets/images/storefronts/clashroyale/divider-scale.png'
import HelmetImage from '@/assets/images/storefronts/clashroyale/helmet.png'
import JoustingLanceImage from '@/assets/images/storefronts/clashroyale/jousting-lance.png'
import CrPassesIcon from '@/assets/images/storefronts/clashroyale/passes-icon.png'
import { PASSES_BG } from '@/features/storefronts/_storeBase/constants'
import SideScrollable from '@/features/storefronts/_storeBase/structure/SideScrollable'
import { useGameSlug } from '@/features/storefronts/game-provider'

import { PassCard } from '../../_storeBase/passCard/PassCard'
import { StoreTypography } from '../../_storeBase/typography/StoreTypography'

import styles from './Passes.module.scss'

interface PassesProps {
  products: ProductV2[]
  background?: boolean
}

//TODO: Remove copy-paste, use common component

const Passes: React.FC<PassesProps> = ({ products, background = true }) => {
  const t = useTranslations()

  const gameSlug = useGameSlug()

  const passes = products.filter((p) => p.contentCounts.SEASON_PASS)

  return passes.length > 0 ? (
    <div
      className={cx(styles.Passes, styles.Background)}
      style={{ ...(background && { backgroundImage: PASSES_BG(gameSlug) }) }}
    >
      <div className={styles.TopDivider}>
        <Image src={DividerImage} alt="divider" fill />
        <div className={styles.TopContentDivider}>
          <div className={styles.TopDividerLeft}>
            <Image src={HelmetImage} alt="helmet" fill />
          </div>
          <div className={styles.TopDividerRight}>
            <Image src={JoustingLanceImage} alt="jousting-lance" fill />
          </div>
        </div>
      </div>
      <div className={styles.Header}>
        <div className={styles.HeaderImage}>
          <Image src={CrPassesIcon} alt="gold-and-event-passes" fill sizes="100px" />
        </div>
        <div id="passes" className={styles.Title}>
          <StoreTypography tag="h2" textSize="xl" style="outlined">
            {t('passes_title')}
          </StoreTypography>
        </div>
      </div>
      <div className={styles.Center}>
        <SideScrollable className={styles.Scrollable} centered>
          {passes.map((pass) => (
            <PassCard key={pass.id} product={pass} />
          ))}
        </SideScrollable>
      </div>
      <div className={styles.BottomDivider}>
        <Image src={DividerImage} alt="divider" fill />
        <div className={styles.BottomDividerContent}>
          <div className={styles.BottomDividerLeft}>
            <Image src={CoinsImage} alt="coins" fill />
          </div>
          <div className={styles.BottomDividerRight}>
            <Image src={ScalesImage} alt="scale" fill />
          </div>
        </div>
      </div>
    </div>
  ) : null
}

export default Passes
